import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg, setToken } from "@/lib/api";
import { Page } from "@/components/SiteLayout";

const LABELS = { kiwify_checkout: "Checkout Kiwify", kiwify_webhook: "Webhook Kiwify", email: "E-mail transacional", ai: "Provedor de IA", contact: "Contato do rodapé" };

export default function DevAccess() {
  const [key, setKey] = useState("");
  const [status, setStatus] = useState(null);
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/system/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);
  const create = async () => {
    setErr("");
    try {
      const r = await api.post("/dev/access", {}, { headers: { "X-Dev-Key": key } });
      setToken(r.data.token);
      navigate("/mapa");
    } catch (e) {
      setErr(errMsg(e));
    }
  };
  return (
    <Page>
      <div className="mx-auto max-w-md px-5 py-10" data-testid="dev-page">
        <h1 className="text-3xl text-stone-900">Modo de teste</h1>
        <p className="mt-2 text-sm text-stone-600">Disponível somente em ambiente de desenvolvimento. Cria um acesso de teste sem pagamento.</p>
        {status && (
          <ul className="mt-6 space-y-1 text-sm" data-testid="dev-integration-status">
            <li>Ambiente: <b>{status.env}</b></li>
            {Object.entries(LABELS).map(([k, l]) => <li key={k}>{l}: {status[k] ? "configurado" : "PENDENTE"}</li>)}
            {Object.entries(status.offers).map(([k, v]) => <li key={k}>Oferta {k}: {v ? "configurada" : "PENDENTE"}</li>)}
          </ul>
        )}
        <input className="field mt-6" type="password" placeholder="Chave de teste" value={key} onChange={(e) => setKey(e.target.value)} data-testid="dev-key-input" />
        <button className="btn-primary mt-3 w-full" onClick={create} data-testid="dev-create-access-button">Criar acesso de teste</button>
        {err && <p className="mt-3 text-sm text-[#8a3f22]" data-testid="dev-error">{err}</p>}
      </div>
    </Page>
  );
}
